import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import { getMlstInterpretation, getMlstStatusDisplay } from './mlstUtils';

const colorBySeverity = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  default: 'default',
};

function MlstChip({ result }) {
  const statusDisplay = useMemo(
    () => getMlstStatusDisplay(result?.status, result?.sequenceType),
    [result?.status, result?.sequenceType]
  );
  const interpretation = getMlstInterpretation(result?.status, result?.sequenceType);

  const tooltipTitle = (
    <Box>
      <div><b>{result?.schemeDisplayName || 'MLST'}</b></div>
      {interpretation && <div style={{ marginTop: 4 }}>{interpretation}</div>}
    </Box>
  );

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <Chip
        size="small"
        color={colorBySeverity[statusDisplay.severity] || 'default'}
        label={statusDisplay.label}
        variant="outlined"
      />
    </Tooltip>
  );
}

export default MlstChip;
